// removed by extract-text-webpack-plugin
module.exports = {"about_layout":"about_layout___JFwY","about_column":"about_column__2tVrE","map":"map__3zFqu","map_caption":"map_caption__364ME"};


//////////////////
// WEBPACK FOOTER
// ./routes/about/style.scss
// module id = HgQI
// module chunks = 9